import React, { memo, useCallback } from 'react'
import classNames from 'classnames'

export interface IFacetRadioProps<T = string> {
  dataTest: string
  icon?: JSX.Element
  label: string
  className?: string
  buttonClassName?: string
  /**
   * @default false
   */
  selected: boolean
  /**
   * @example 'dry_van'
   */
  value: T
  onClick: (value: T) => void
}

const FacetRadio = memo<IFacetRadioProps>(
  ({ buttonClassName, className, dataTest, icon, label, onClick, selected = false, value }) => {
    const buttonClasses = classNames('filter-pill tl facet', buttonClassName, {
      'applied bg-tertiary': selected,
    })

    const labelClasses = classNames('nowrap', {
      'text-default': !selected,
      'ml4 pl2 pr2': icon,
    })

    const buttonClickHandler = useCallback(() => {
      onClick(value)
    }, [onClick, value])

    return (
      <div className={className} data-test={dataTest}>
        <button className={buttonClasses} type='button' onClick={buttonClickHandler}>
          <div className='flex flex-row items-center relative'>
            {icon && <div className='flex flex-row items-center pr2 prefix-icon'>{icon}</div>}
            <b className={labelClasses}>{label}</b>
          </div>
        </button>
      </div>
    )
  }
)

export default FacetRadio
